import React from 'react'
import { Link, useNavigate } from "react-router-dom";

const divStyle = {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '5px'
};

function Abouthome() {
    const navigate = useNavigate();
    navigate("users");
    return (
        <div className="main-content">
            <div id="rs-about" className="rs-about style1 pt-30 pb-30 md-pt-30 md-pb-30">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 order-last padding-0 md-pl-15 md-pr-15 md-mb-30">
                            <div className="img-part">
                                <img className="" src="assets/images/about.jpg" alt="About " />
                            </div>
                        </div>
                        <div className="col-lg-6 pr-20 md-pr-15">
                            <div className="sec-title">
                                <h2 className="title mb-17 orange" style={{fontSize: "3rem"}}>About <span style={{color: "#e12323"}}>CF<span style={{color: "#ffc647"}}>IITM</span></span></h2>
                                
                                <div className="desc">Canadian Friends of IIT Madras is an organization that acts as a bridge between the past, present and future students of IITM in Canada. Your support fuels education and funds research, propelling the vision of 'IITM for All.' Alumni, like you, hold the power to make a lasting impact by nurturing homegrown talents and enriching IIT Madras.
                                <br/>To empower the next generation of leaders, thinkers, and innovators, we seek your support. Excellence is a collective journey, and we invite our Canadian alumni and friends to join us. Your contributions shape the future, and upgrade facilities, become a vital part of empowering IIT Madras for a future of boundless possibilities.</div>
                            </div>
                            <div className="btn-part" style={divStyle}>                                        
                                        <Link className="btn readon2 orange-transparent" to="/givingopportunity" onClick={() => navigate()}>Explore Giving Opportunities</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Abouthome
